const Mensagens = [
    {
        id: 1,
        titulo: 'Lorem ipsum',
        mensagem: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi luctus, odio eget tempor sagittis.'
    },
    {
        id: 2,
        titulo: 'Dolor sit amet',
        mensagem: 'Dolor sit amet, consectetur adipiscing elit. Morbi luctus, odio eget tempor sagittis, quam sem mattis quam, nec tempor velit.'
    },
    {
        id: 3,
        titulo: 'Morbi luctus',
        mensagem: ' Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.'
    }
]

export default Mensagens;